module.exports = __webpack_public_path__ + "img/programme5.32503c19.png";